module.exports = __webpack_public_path__ + "img/selfAdhesive6.9126d1fc.jpg";